import CheckoutPage from '@/pages/CheckoutPage';
import { ROUTES } from './routes.config';
import { AuthGuard } from '@/rtkQuery/features/services/auth';

export const CheckoutPageRoutes = {
    path: ROUTES.CHECKOUT,
    element: <AuthGuard><CheckoutPage /></AuthGuard>,
};
